import { LoadableAfterPaint } from '@confluence/loadable';

import { TwgExplorerSectionLoadingPlaceholder } from '../src/ui-components/TwgExplorerSectionLoadingPlaceholder.tsx';

export const TwgExplorerSectionLoader = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-twg-explorer-section" */ '../src/TwgExplorerSection.tsx'
			)
		).TwgExplorerSection,
	loading: TwgExplorerSectionLoadingPlaceholder,
});
